import { Block, Inline } from '@contentful/rich-text-types';
import { Next, NodeRenderer } from '@contentful/rich-text-html-renderer';

export const getHyperlinkHtml = ((node: Block | Inline, next: Next) =>
  // I leave it as possible implementation for the future.
  // `<a href="https://google.com" target="_blank" rel="noreferrer noopener">${next(
  //   node.content,
  // )} </a>`
  'Hyperlinks are not yet supported in this feature.') as NodeRenderer;
